// src/contexts/AuthContext.tsx
import React, { createContext, useState, useContext, ReactNode } from 'react';

// Define the shape of the context
interface AuthContextType {
  userId: string | null; // User ID or null if not logged in
  setUserId: React.Dispatch<React.SetStateAction<string | null>>; // Function to update userId
}

// Create the context with an initial value of undefined
export const AuthContext = createContext<AuthContextType | undefined>(undefined);

// Provider component to manage authentication state
export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [userId, setUserId] = useState<string | null>(null); // Initialize userId as null

  return (
    <AuthContext.Provider value={{ userId, setUserId }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to access the context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};